export type SoundfontSource =
  | { kind: "catalog"; id: string; url: string; label: string }
  | { kind: "url"; url: string }
  | { kind: "file"; url: string; name: string };

export const isSoundfontSource = (value: unknown): value is SoundfontSource => {
  if (!value || typeof value !== "object") return false;
  const v = value as { kind?: unknown; url?: unknown };
  if (typeof v.url !== "string" || v.url.length === 0) return false;
  return v.kind === "catalog" || v.kind === "url" || v.kind === "file";
};

/**
 * Загружает сырые байты SF2 по `SoundfontSource` (catalog/url/file — все
 * используют `fetch(source.url)`). Бросает `Error` при сетевой ошибке или
 * не-HTTP-ответе. Выделено из `soundfontEngine.ts`, чтобы консьюмеры вроде
 * web-`useProgramMap` могли загружать байты того же звука для построения
 * `ProgramMap` без дублирования логики.
 */
export const loadSoundfontBytes = async (source: SoundfontSource): Promise<Uint8Array> => {
  const res = await fetch(source.url);
  if (!res.ok) throw new Error(`HTTP ${res.status} при загрузке ${source.url}`);
  return new Uint8Array(await res.arrayBuffer());
};